import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

/**
 * A wrapper for the addEventListener method on EventTarget objects.
 * This returns a function that removes the listener safely (i.e. with
 * the same parameters as those used during registration).
 */

export function addEventListener(element, type, callback, options) {
  element.addEventListener(type, callback, options);
  // We store the unsubscriber in a reference, so that when a caller unsubscribes,
  // we can clear the reference and free up any references to the DOM element, callback,
  // etc. This means callers don't have to be careful about clearing out the unsubscriber they
  // receive from us.
  const ref = {
    unsubscribe: () => element.removeEventListener(type, callback, options)
  };
  return () => {
    ref.unsubscribe?.();
    ref.unsubscribe = undefined;
  };
}

/**
 * A class that can be used to manage DOM event listener registrations.
 * Use this class to add all your listeners, and then clean them up by calling
 * unregister.
 */
export class EventListenerManager {
  constructor() {
    _defineProperty(this, "managedListeners", void 0);
    this.managedListeners = [];
  }

  /**
   * Add an event listener that will be managed by this class.
   */

  registerEventListener(element, type, callback, options) {
    this.managedListeners.push(addEventListener(element, type, callback, options));
  }

  /**
   * Unregisters all registered event listeners.
   */
  unregister() {
    while (this.managedListeners.length > 0) {
      const listener = this.managedListeners.pop();
      listener?.();
    }
  }
}
//# sourceMappingURL=EventRegistration.js.map
